// test1200
(1200 && 0);
